import React from 'react';
import { IconProps } from '.';

const SvgCirclePlusFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-.75 6v4.25H7v1.5h4.25V17h1.5v-4.25H17v-1.5h-4.25V7h-1.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCirclePlusFill;
